<template>
  <footer>
    <div class="container">
      <div class="top">
        <div class="col-md-4 top-col align-start">
          <img class="logo" src="@/assets/img/auzoneLogo.svg" alt="image">
          <p>Founded in 2001 as a pioneer in the embedded design and computer vision industry, Au-Zone has become a trusted provider of embedded AI and machine learning (ML) software, hardware and reference designs for 3D spatial perception in unstructured and harsh environments.</p>
          <br>
          <span class="scroll-animated-from-bottom">© 2025 by Au-Zone Technologies</span>
        </div>
        <div class="col-md-4 top-col">
          <div class="links">
            <a href="https://edgefirst.ai" target="_blank" rel="noopener">EdgeFirst AI</a>
            <a href="https://edgefirst.ai/about-us" target="_blank" rel="noopener">About Us</a>
            <a href="https://edgefirst.ai/partners" target="_blank" rel="noopener">Partners</a>
            <a href="https://edgefirst.ai/news" target="_blank" rel="noopener">Media and Events</a>
            <a href="https://edgefirst.ai/services" target="_blank" rel="noopener">Services</a>
          </div>
        </div>
        <div class="col-md-4 top-col text-center">
          <p>
            Au-Zone Technologies<br>
            #302 - 1240 20 Ave SE<br>
            Calgary AB T2G 1M8
          </p>
          <p class="mt-4">
            support@au-zone.com
          </p>
          <p class="mt-1">
            403.261.9985
          </p>
          <div class="mt-4 social">
            <a
              href="https://www.youtube.com/@Au-zone"
              target="_blank"
              rel="noopener"
              title="YouTube"
            >
              <img
                src="@/assets/landing-page/assets/images/youtube_line.svg"
                alt="YouTube"
              >
            </a>
            <a
              href="https://www.linkedin.com/company/au-zone-technologies"
              target="_blank"
              rel="noopener"
              title="LinkedIn"
            >
              <img
                src="@/assets/landing-page/assets/images/linkedin_white.png"
                alt="LinkedIn"
              >
            </a>
            <a
              href="https://huggingface.co/EdgeFirst"
              target="_blank"
              rel="noopener"
              title="Hugging Face"
              class="social__text-icon"
            >🤗</a>
            <a
              href="https://github.com/EdgeFirstAI"
              target="_blank"
              rel="noopener"
              title="GitHub"
              class="social__text-icon"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61-.546-1.385-1.335-1.755-1.335-1.755-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/></svg>
            </a>
            <a
              href="https://discord.com/invite/sRUhvCHgwe"
              target="_blank"
              rel="noopener"
              title="Discord"
              class="social__text-icon"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/></svg>
            </a>
          </div>
        </div>
      </div>
      <div class="bottom">
        <button class="back-to-top-btn" @click="$emit('scroll-to-top')">
          <SVGIcon
            :width="'24px'"
            :height="'24px'"
            :iconName="'double_arrow_up'"
          />
          Back To Top
        </button>
      </div>
    </div>
  </footer>
</template>

<script setup>
import SVGIcon from '@/components/SVGIcon.vue';

defineEmits(['scroll-to-top']);
</script>

<style lang="scss" scoped>
footer {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  background-image: url('@/assets/landing-page/assets/images/footer.svg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
}

.container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.top {
  display: flex;
  flex-direction: row;
  margin: 2rem 2rem 0 2rem;
}

@media (max-width: $breakpoint-md) {
  .top {
    flex-direction: column;
    gap: 1rem;
  }
}

.top-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.links {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: center;
}

.logo {
  height: 100px;
}

.bottom {
  display: flex;
  flex-direction: row;
  margin: 0 2rem 2rem 2rem;
}

.social {
  gap: 12px;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  align-items: center;

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    cursor: pointer;
  }
}

.social__text-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: white;
  opacity: 0.85;
  font-size: 1.2rem;
  line-height: 1;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
  }

  &:hover {
    opacity: 1;
  }
}

.back-to-top-btn {
  border: 1px solid white;
  border-radius: 2px;
  margin: auto;
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
}

a {
  color: #cccccc;
  text-decoration: none;
  transition: color 0.2s;
  cursor: pointer;
}

a:hover {
  color: #9370db;
  text-decoration: underline;
}

a:visited {
  color: #cccccc;
}
</style>
